// Vendors
import { all, fork } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';

// Saga
import { watchInvoice } from './features/invoice/invoiceSaga';
import { watchAccountSaga } from './features/account/accountSaga';
import { watchTransaction } from './features/transaction/transactionSaga';

export default function* rootSaga(): SagaIterator {
  yield all([fork(watchInvoice), fork(watchAccountSaga), fork(watchTransaction)]);
}
